import React, { useState } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Input } from 'reactstrap';
import { Trans, useTranslation } from 'react-i18next';
import { NotificationManager } from 'react-notifications';
import axios from 'axios';

export const readFileAsync = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = (event) => {
      const content = event.target.result;
      resolve(content);
    };

    reader.onerror = (error) => {
      reject(error);
    };

    reader.readAsArrayBuffer(file);
  });
};


const ImportModal = ({ isOpen, toggle, title, importantNotes, handleUpload, templateName, directChange, children, onDownload, showTemplate = true }) => {

  const { t } = useTranslation()

  const [selectedFile, setSelectedFile] = useState(null);
  const [isDownloading, setDownloading] = useState(false);

  const handleFileChange = (event) => {
    const file = event.target.files[0];

    if (file) {
      setSelectedFile(file);
    }
  };

  const handleModalClose = () => {
    setSelectedFile(null);
    toggle();
  };


  const handleChange = directChange || handleFileChange

  const fileName = templateName || `Import${title}Template`

  const formatType = '.xlsx'

  const downloadTemplate = () => {
    setDownloading(true)
    return axios({
      url: `/api/download_template?file_name=${fileName}${formatType}`,
      method: 'GET',
      responseType: 'blob',
    }).then((response) => {
      const link = document.createElement("a");
      link.target = "_blank";
      link.download = `${title} Import Template${formatType}`
      link.href = URL.createObjectURL(
        new Blob([response.data], { type: "xlsx" })
      );
      link.click();
      setDownloading(false)
      NotificationManager.success(t('Template is downloaded'));
    }).catch((err) => {
      NotificationManager.error(t('Error at downloading'));
      setDownloading(false)
    });
  };

  const fadeClass = {
    className: `fade-out${selectedFile ? ' hidden' : ''}`
  }

  return (
    <Modal isOpen={isOpen} toggle={handleModalClose} contentLabel="File Upload Modal">
      <ModalHeader toggle={handleModalClose}>Bulk Import Your {title}</ModalHeader>
      <ModalBody>
        <div>
          <div className="mb-2">
            {showTemplate && <>
              <p {...fadeClass}>
                <Trans>The Excel template file will have example data for guidance. </Trans>
                <Trans>The file has the exact column headings that Hesaab needs to import your {title.toLowerCase()} data.</Trans>
              </p>
              
              {isDownloading ? <Button size="md" color="primary" className="mb-2 ml-0" disabled>
                <span className="fa fa-spinner fa-spin" /> Downloading</Button>
                :(
                  onDownload?
                    <Button size="md" color="primary" className="mb-2 ml-0" onClick={onDownload}>
                      <i className="fas fa-file-excel mr-2"/><Trans>Download Template</Trans>
                    </Button>
                    :
                    <Button size="md" color="primary" className="mb-2 ml-0" onClick={downloadTemplate}>
                      <i className="fas fa-file-excel mr-2"/><Trans>Download Template</Trans>
                    </Button>

                )
              }
            </>}
          </div>
          {importantNotes && 
            <div className="mb-2">
              <p style={{ color: "orange", fontSize: "1.1em" }}>
                <Trans>IMPORTANT: Things to Remember when Importing the File.</Trans>
              </p>
              <div style={{ padding: 10, backgroundColor: "#F7F8FD" }}>
                <ul className="list-unstyled text-muted">
                  {importantNotes.map((note, index) => (
                    <li key={index} className="mb-2">
                      {note}
                    </li>
                  ))}
                </ul>
              </div>
              <p className="pt-2">
                <Trans>These details need to be checked and fulfilled for the import to work properly.</Trans>
              </p>
            </div>
          }
          {showTemplate && <p {...fadeClass}><Trans>Once you have downloaded the template file, fill in the details and Upload it here.</Trans></p>}
          <div className="input-group input-group-lg">
            <div className="custom-file">
              <input name="attachment" type="file" className="custom-file-input" onChange={handleChange} />
              <label className="custom-file-label" htmlFor="customFileInput" style={{ overflow: "hidden" }}>{selectedFile?.name || t("Select File")}</label>
            </div>
            <div className="input-group-append">
              <button className="btn btn-default custom" type="button" id="uploadBtn" onClick={() => { setSelectedFile(null) }}><Trans>Clear</Trans></button>
            </div>
          </div>
        </div>
        <div className='my-2'>{children}</div>
      </ModalBody>
      <ModalFooter>
        {selectedFile && (
          <Button color="primary" onClick={() => {handleUpload(selectedFile); setSelectedFile(null)}}><Trans>Upload</Trans></Button>
        )}
        <Button color="secondary" onClick={handleModalClose}><Trans>Close</Trans></Button>
      </ModalFooter>
    </Modal>
  );
};

export default ImportModal;
